import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import OrganizationDivisionAppResource from './OrganizationDivisionAppResource';
import OrganizationMemberAppResource from './OrganizationMemberAppResource';
import OrganizationOperationAppResource from './OrganizationOperationAppResource';
import LuOrganizationReportingRoleAppResource from './LuOrganizationReportingRoleAppResource';

class OrganizationMemberReportAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'organization-member-report';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'organizations/members/reports';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'createdAt',
            'updatedAt',
            'organizationMemberUuid',
            'organizationDivisionUuid',
            'organizationReportingRoleUuid',
            'organizationOperations',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            organizationMember: OrganizationMemberAppResource,
            organizationDivision: OrganizationDivisionAppResource,
            organizationOperations: OrganizationOperationAppResource,
            organizationReportingRole: LuOrganizationReportingRoleAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            division: 'organization_division_uuid',
            organizationMember: 'organization_member_uuid',
            reportingRole: 'organization_reporting_role_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            organizationDivisionUuid: {
                type: 'string',
            },
            organizationMemberUuid: {
                type: 'string',
                presence: true,
            },
            organizationReportingRoleUuid: {
                type: 'string',
            },
            organizationOperations: {
                type: 'array',
            }
        };
    }

}

export default OrganizationMemberReportAppResource;
